<template>
    <section id="master-start-quiz" class="layout layout-scale quiz-layout" :class="{ 'opacity-0': !isAlreadyShow }">
        <div class="header pb-3 md:pb-0">
            <div class="text-center md:text-left">
                <HeaderLogo
                    :warning-message="$t('playlive_alert_leave')"
                    logo-width="12"
                    color="var(--ui-color)"
                    shadow="var(--question-shadow-color)"
                    class="logo inline-block"
                ></HeaderLogo>
            </div>
        </div>
        <div class="content">
            <div class="content-container max-w-lg mx-auto">
                <div class="flex items-center justify-center mb-4 md:mb-10">
                    <div
                        :style="`background-image: url(${getQuizImage(getQuiz, true)})`"
                        class="layout-title-img w-48 h-48 md:w-64 md:h-64 border-ui-style bg-cover bg-center bg-norepeat"
                    ></div>
                </div>
                <div class="text-center">
                    <h1
                        class="theme-question-text-color theme-question-shadow text-center font-size-28 md:font-size-28 font-bold text-white mt-0 mb-10"
                        v-html="title"
                    ></h1>
                    <!-- <h2 class="text-white font-normal font-size-16 md:font-size-18 mt-0 mb-4 whitespace-pre-wrap" v-html="description"></h2> -->
                </div>

                <div class="text-center">
                    <p
                        id="desc"
                        class="theme-question-text-color theme-question-shadow text-center font-size-16 md:font-size-16 font-bold text-white mt-0 mb-10"
                        v-if="description"
                        v-html="setFormatText(description, 10)"
                    ></p>
                </div>

                <div class="text-center flex items-center flex-col justify-center">
                    <h3 class="theme-question-text-color uppercase font-size-18 font-bold text-white mt-0">
                        <span class="block theme-question-shadow"
                            >{{ questionCount }}
                            {{ questionCount > 1 ? $t('playlive_questions') : $t('playlive_question') }}</span
                        >
                    </h3>

                    <div id="upgrade-limit-player" class="text-center text-white pb-1 mb-2">
                        <div class="text-center mt-2">
                            <span class="theme-question-text-color theme-question-shadow font-size-16 font-bold">
                                {{ $t('playlive_limit_player', { limitPlayer }) }} -
                                <a
                                    @click.prevent="showPaymentPopup = true"
                                    class="theme-question-text-color theme-question-shadow text-white"
                                    href=""
                                >
                                    {{ $t('purchase_header_upgrade') }}
                                </a>
                            </span>
                        </div>
                    </div>

                    <div v-if="isPlayTogether" class="mb-4">
                        <Checkbox
                            id="join-as-master"
                            v-model="joinAsMaster"
                            :label="$t('playlive_quizmaster')"
                            class="mr-3 mr-md-2"
                        />
                        <Checkbox id="join-as-player" v-model="joinAsPlayer" :label="$t('playlive_player')" />
                    </div>

                    <div class="text-center text-white pb-2">
                        <div
                            id="setting-live-button"
                            @click="handleShowQuizSetting"
                            class="flex justify-center items-center cursor-pointer"
                        >
                            <i class="fas fa-cog font-size-18 mr-2 theme-question-text-color theme-question-shadow"></i>
                            <h2 class="theme-question-text-color theme-question-shadow font-size-16">
                                {{ $t('playlive_button_setting') }}
                            </h2>
                        </div>
                    </div>

                    <!-- For mobile -->
                    <button
                        v-if="isMobile"
                        @click="checkOrderAbility"
                        :disabled="questions && questions.length == 0"
                        id="start-live-btn"
                        class="theme-button btnStart cursor-pointer inline-block relative btn btn-large font-size-22 font-opensans uppercase inline-block"
                    >
                        {{ $t('playlive_button_start') }}
                    </button>
                </div>
            </div>
        </div>

        <!-- For desktop -->
        <div v-if="!isMobile" class="footer">
            <div class="text-center">
                <button
                    @click="checkOrderAbility"
                    :disabled="questions && questions.length == 0"
                    id="start-live-btn"
                    class="theme-button btnStart cursor-pointer inline-block relative btn btn-large font-size-22 font-opensans uppercase inline-block"
                >
                    {{ $t('playlive_button_start') }}
                </button>
            </div>
        </div>

        <QuizSettingModal
            v-if="showQuizSettingModal"
            :delayAnswer="delayAnswer"
            :delayQuestion="delayQuestion"
            :timeLimit="timeLimit"
            :masterSound="masterSound"
            :playerSound="playerSound"
            :progress-bar-status="progressBarStatus"
            :masterResultSetting="masterResultSetting"
            @close="handleQuizSetting"
        ></QuizSettingModal>
        <div>
            <TopRightMenu
                :login-status="loginStatus"
                @click-your-quiz-link="clickToMyQuiz()"
                @click-new-quiz="clickNewQuiz()"
                @click-edit-profile="clickEditProfile()"
                @click-order="clickOrder()"
                @click-subscribe-plan="clickSubscribePlan()"
                @click-subpage="clickSubpage"
                @click-buy-credit="clickBuyCredit()"
                @open-auth-popup="showAuthPopup = true"
            />
            <AuthPopup
                v-if="showAuthPopup"
                ref="authPopup"
                :webview-redirect-to="createWebviewRedirectTo()"
                @login-success="loginSuccess"
                @register-success="loginSuccess"
                @close="showAuthPopup = false"
            />
        </div>

        <PaymentPopup
            :quiz-id="id"
            :payment-title="$t('purchase_header_upgrade')"
            @close="showPaymentPopup = false"
            @success="paymentSuccess"
            v-if="showPaymentPopup"
        />
    </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { currentUser, isLoggedIn } from '@/lib/user'
import HeaderLogo from '@/components/HeaderLogo.vue'
import AuthPopup from '@/components/AuthPopup'
import TopRightMenu from '@/components/TopRightMenu'
import Checkbox from '@/components/Checkbox'
import Background from '@/lib/background.js'
import ResizeScale from '@/lib/resize-scale.js'
import AuthPopupMixin from '@/mixins/auth-popup'
import appConfig from '@/app.config.js'
import helper from '@/lib/helper.js'
import popup from '@/lib/popup.js'
import PaymentPopup from '@/components/PaymentPopup.vue'
import NoImage from '@/assets/no-image.jpg'
import QuizSettingModal from '@/components/QuizSettingModal.vue'
import helperMixins from '@/mixins/helper.js'
import { playerSocketSetting } from '@/mixins/live-quiz-socket.js'
import { startIntroMasterStart } from '@/lib/intro.js'
import introJsData from '@/mixins/introjs-data'

export default {
    mixins: [AuthPopupMixin, helperMixins, introJsData],

    components: {
        HeaderLogo,
        AuthPopup,
        TopRightMenu,
        Checkbox,
        PaymentPopup,
        QuizSettingModal
    },

    sockets: {
        master_pressed_pre_start: function () {
            setTimeout(
                function () {
                    let query = {}

                    if (this.joinAsPlayer) {
                        query['type'] = this.$route.query.type
                    }

                    this.$store.commit('toggleMainLoader', false)
                    this.$router.push({
                        name: 'share',
                        query: query
                    })
                }.bind(this),
                500
            )
        },

        master_send_user_limit: function (data) {
            this.limitPlayer = data.limit_player
        },

        master_receive_user_limit: function (data) {
            this.limitPlayer = data.limit_player
        },

        master_clear_other_window: function () {
            popup.alert(
                'You just started this quiz in another window or on another device. This page will be closed.',
                () => {
                    window.location.href = this.$router.resolve({ name: 'my-quiz' }).href
                }
            )
        },

        ...playerSocketSetting
    },

    computed: {
        ...mapGetters({
            audioSpotify: 'getSpotifyAudio',
            delayAnswer: 'getDelayAnswer',
            delayQuestion: 'getDelayQuestion',
            timeLimit: 'getTimeLimit',
            masterSound: 'getMasterSound',
            playerSound: 'getPlayerSound',
            progressBarStatus: 'getProgressBarStatus',
            masterResultSetting: 'getMasterResultSetting',
            getQuiz: 'getQuiz'
        }),

        ...mapState({
            id: state => state.question._id,
            title: state => state.question.title,
            allowHtml: state => state.question.allow_html,
            code: state => state.question.code,
            type: state => state.question.type,
            description: state => state.question.description,
            image: state => state.question.image,
            backgroundType: state => state.question.background_type,
            backgroundColor: state => state.question.background_color,
            backgroundImage: state => state.question.background_image,
            blur: state => state.question.background_image_blur,
            darken: state => state.question.background_image_darken,
            fromQuizId: state => state.question.from_quiz_id,
            frontPageSetting: state => state.frontPageSetting,
            isCanEdit: state => state.question.user_id === currentUser().id,
            questions: state => state.question.questions,
            approvalStatus: state => state.question.approval_status,
            age: state => state.question.age,
            difficult: state => state.question.difficult,
            orderAbility: state => state.orderAbility,
            isFrontPageQuiz: state => state.question.is_frontpage_quiz
        }),

        isPlayTogether() {
            return this.$route.query.type == 'pt'
        },

        editPath() {
            if (this.id) {
                return {
                    name: 'my-quiz',
                    params: {
                        id: this.id
                    }
                }
            }

            return {
                name: 'my-quiz'
            }
        },

        questionCount() {
            return this.questions.filter(item => {
                return item.status
            }).length
        }
    },

    created() {
        this.addStyleSheet(this.code)
    },

    mounted: function () {
        let localSetting = JSON.parse(localStorage.getItem('live-quiz-setting'))
        if (localSetting) {
            this.$store.commit('updateDelayAnswer', localSetting.delayAnswer)
            this.$store.commit('updateDelayQuestion', localSetting.delayQuestion)
            this.$store.commit('updateTimeLimit', localSetting.timeLimit)
            this.$store.commit('updateMasterSound', localSetting.masterSound)
            this.$store.commit('updatePlayerSound', localSetting.playerSound)
            this.$store.commit('updateProgressBarStatus', localSetting.progressBarStatus)
            this.$store.commit('updateMasterResultSetting', localSetting.masterResultSetting)
            this.setSocketSetting()
        }

        let backgroundColor =
            this.frontPageSetting.background_type === ''
                ? appConfig.defaultBackgroundColor
                : this.frontPageSetting.background_color
        let color = this.backgroundType === 'image' ? backgroundColor : this.backgroundColor

        if (this.backgroundType == 'image' && !this.backgroundColor) {
            color = appConfig.defaultBackgroundColor
        }

        if (this.backgroundType == 'image' && this.backgroundColor) {
            color = this.backgroundColor
        }

        if (this.fromQuizId) {
            this.$store.commit('masterQuizId', this.fromQuizId)
        }

        new Background({
            color: this.getQuiz.theme_name ? this.getQuiz.themes[this.getQuiz.theme_name].background_color : color,
            image: this.getQuiz.theme_name
                ? this.getQuiz.themes[this.getQuiz.theme_name].background_image
                : this.backgroundImage,
            type: this.backgroundType,
            blur: this.blur,
            darken: this.darken,
            navText: this.frontPageSetting.nav_text,
            useTheme: this.getQuiz.theme_name ? true : false
        })

        this.$store.dispatch('validateSubscription')

        this.$socket.emit('master_set_user_limit', {
            user_id: currentUser().id,
            room: this.code
        })

        this.$store.dispatch('refreshToken')

        this.$store.commit('player/clearCoin')

        // Receive custom event componentAlready
        window.addEventListener('componentAlready', () => {
            if (this.$route.name === 'start-quiz') {
                this.resizeScaleQuizFrame()
            }
        })

        this.checkMatchMediaScreen()

        if (!this.isPlayTogether) {
            //Remove step join as master/player
            this.stepTour4 = this.stepTour4.filter(
                step => step.element !== '#join-as-master' && step.element !== '#join-as-player'
            )
        }

        setTimeout(() => {
            startIntroMasterStart(this.stepTour4)
        }, 1000)
    },

    destroyed: function () {
        this.removeTouchActionNone()
    },

    data() {
        return {
            joinAsMaster: true,
            joinAsPlayer: false,
            limitPlayer: 0,
            showPaymentPopup: false,
            isAlreadyShow: false,
            noImage: NoImage,
            isClickStart: false,
            showQuizSettingModal: false,
            isMobile: false
        }
    },

    watch: {
        joinAsMaster(val) {
            this.joinAsMaster = val

            if (val) {
                this.joinAsPlayer = false
            }

            if (!val && !this.joinAsPlayer) {
                this.joinAsMaster = true
            }
        },

        joinAsPlayer(val) {
            this.joinAsPlayer = val

            if (val) {
                this.joinAsMaster = false
            }

            if (!val && !this.joinAsMaster) {
                this.joinAsPlayer = true
            }
        }
    },

    methods: {
        checkMatchMediaScreen() {
            const match = window.matchMedia('(min-width: 768px)')

            if (match.matches) {
                this.isMobile = false
            } else {
                this.isMobile = true
            }
            match.addEventListener('change', event => {
                if (event.matches) {
                    this.isMobile = false
                } else {
                    this.isMobile = true
                }
            })
        },

        async checkOrderAbility() {
            if (
                !this.isFrontPageQuiz &&
                this.type != 'poll' &&
                !this.orderAbility.has_subscribed &&
                !this.orderAbility.is_24hrs_access
            ) {
                const message = this.$t('playlive_alert_no_premium')
                const swalOption = {
                    closeOnClickOutside: false,
                    buttons: {
                        confirm: {
                            text: 'Upgrade',
                            value: true,
                            className: 'btn font-opensans text-md system-button-color system-button-text-color'
                        },
                        cancel: {
                            text: 'Play',
                            visible: true,
                            value: false,
                            className: 'btn default font-opensans text-md'
                        }
                    }
                }

                const upgrade = await swal(message, swalOption)

                if (upgrade) {
                    this.showPaymentPopup = true
                } else {
                    this.handleCreateQuestion()
                }
            } else {
                this.handleCreateQuestion()
            }
        },

        handleCreateQuestion() {
            document.querySelector('#start-live-btn').style.pointerEvents = 'none'

            if (this.isClickStart) {
                return
            }

            this.isClickStart = true

            this.audioSpotify.src = null

            this.$store.commit('toggleMainLoader', true)

            const playingType = this.joinAsPlayer ? 'play_together' : ''
            var masterName = playingType == 'play_together' ? 'Master' : ''

            if (isLoggedIn()) {
                masterName = helper.shortName(currentUser().name)
            }

            this.$socket.emit('master_press_pre_start', {
                room: this.code,
                user_id: currentUser().id,
                name: masterName,
                playing_type: playingType
            })

            this.$store.commit('setUserPlayingInfo', {
                room: this.code,
                name: masterName,
                as: 'master'
            })

            this.$store.dispatch('enableNoSleep')
            this.$store.dispatch('createLog', {
                type: 'user_start_quiz',
                data: {
                    quiz_id: this.fromQuizId ? this.fromQuizId : this.id,
                    title: this.title
                }
            })
            this.$store.commit('player/joinAsPlayer', this.joinAsPlayer)
            this.$store.commit('player/isPlayTogether', this.isPlayTogether)
            this.$store.commit('player/toggleQuizPlayerSound', this.playerSound)
            this.$store.commit('player/updateProgressBarStatus', this.progressBarStatus)
        },

        handleShowQuizSetting() {
            this.showQuizSettingModal = true
        },

        handleQuizSetting(answerDelay, questionDelay, limitTime, master, player, progressBarStatus, masterResult) {
            let liveQuizSetting = {
                delayAnswer: answerDelay,
                delayQuestion: questionDelay,
                timeLimit: limitTime,
                masterSound: master,
                playerSound: player,
                progressBarStatus: progressBarStatus,
                masterResultSetting: masterResult
            }
            localStorage.setItem('live-quiz-setting', JSON.stringify(liveQuizSetting))
            this.$store.commit('updateDelayAnswer', answerDelay)
            this.$store.commit('updateDelayQuestion', questionDelay)
            this.$store.commit('updateTimeLimit', limitTime)
            this.$store.commit('updateMasterSound', master)
            this.$store.commit('updatePlayerSound', player)
            this.$store.commit('updateProgressBarStatus', progressBarStatus)
            this.$store.commit('updateMasterResultSetting', masterResult)
            this.setSocketSetting()
            this.showQuizSettingModal = false
        },

        resizeScaleQuizFrame() {
            const contentElem = document.getElementsByClassName('content-container')[0]
            const layoutElem = document.getElementsByClassName('layout')[0]
            const headerElem = document.getElementsByClassName('header')[0]
            const footerElem = document.getElementsByClassName('footer')[0]
            const footerHeight = footerElem.getBoundingClientRect().height
            const headerHeight = headerElem.getBoundingClientRect().height
            const uselessHeight = headerHeight + footerHeight

            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            new ResizeScale({
                width: contentElem.getBoundingClientRect().width,
                height: contentElem.getBoundingClientRect().height,
                child: contentElem,
                parent: layoutElem,
                uselessHeight: uselessHeight,
                noTransForm: false
            })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')

            this.isAlreadyShow = true
        },

        paymentSuccess(payload) {
            // this.$store.commit('toggleMainLoader', true)
            this.$socket.emit('master_make_payment_success', {
                user_id: currentUser().id,
                order_id: payload.order_id,
                room: this.code
            })

            this.$store.dispatch('findOrderAbility')
        },

        setSocketSetting() {
            this.$socket.emit('master_toggle_play_song_user', {
                room: this.code,
                player_sound: this.playerSound,
                delay_answer: this.delayAnswer,
                delay_question: this.delayQuestion,
                time_limit: this.timeLimit,
                progress_bar_status: this.progressBarStatus
            })
        },

        setFormatText: helper.setFormatText
    }
}
</script>

<style lang="scss" scoped>
#master-start-quiz {
    .logo {
        @media (max-width: 768px) {
            max-width: 8rem !important;
        }
    }

    .text-shadow {
        text-shadow: 2px 2px 3px rgb(0, 0, 0);
    }
}

.layout {
    height: calc(100vh - 2rem);
    height: calc((var(--vh, 1vh) * 100) - 2rem);

    @media screen and (max-width: 1079px) {
        height: auto;
    }
}
</style>
